import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useLocation } from "react-router-dom";
import { v4 as uuid } from "uuid";

import {
    Box,
    Button,
    ButtonGroup,
    Grid,
    IconButton,
    Modal,
    TextField,
    Typography,
} from "@mui/material";

import tableIcons from "../tableFormatting/tableIcons";

import "./styles.css";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // height: "80vh",
    width: "80vw",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  

const NanoCompModal = ({ name }) => {

    const location = useLocation();
    const pageData = location.state;
    const auth = useSelector(state => state.firebase);

    // console.log(pageData)
    // const [progressData, setProgressData] = useState(pageData);

    const [open, setOpen] = useState(false);
    
    const [submissionData, setSubmissionData] = useState([]);
    const [selectedDataSet, setSelectedDataSet] = useState(1);

    const questions = [
        {
          questionText: `Is ${name} related to any of the following?`,
          answerOptions: [
            { answerText: 'Machine Learning', isCorrect: true },
            { answerText: 'Media Design', isCorrect: false },
            { answerText: 'Computers', isCorrect: true },
            { answerText: 'Cuisine', isCorrect: false },
          ],
        },
        {
          questionText: `When was ${name} invented?`,
          answerOptions: [
            { answerText: '1979', isCorrect: false },
            { answerText: '2001', isCorrect: true },
            { answerText: '2022', isCorrect: false },
            { answerText: '2002', isCorrect: false },
          ],
        },
        {
          questionText: `Who was the creator of ${name}?`,
          answerOptions: [
            { answerText: 'Apple', isCorrect: true },
            { answerText: 'Intel', isCorrect: false },
            { answerText: 'Amazon', isCorrect: false },
            { answerText: 'Microsoft', isCorrect: false },
          ],
        },
        {
          questionText: `How relevant is ${name} in modern society?`,
          answerOptions: [
            { answerText: '1 - Not very', isCorrect: false },
            { answerText: '2 - Somewhat', isCorrect: false },
            { answerText: '3 - Quite', isCorrect: false },
            { answerText: '4 - Very', isCorrect: true },
          ],
        },
      ];

      const [currentQuestion, setCurrentQuestion] = useState(0);
      const [showScore, setShowScore] = useState(false);
      const [score, setScore] = useState(0);
  
      const handleAnswerOptionClick = (isCorrect) => {
          if (isCorrect) {
              setScore(score + 1);
          }
  
          const nextQuestion = currentQuestion + 1;
          if (nextQuestion < questions.length) {
              setCurrentQuestion(nextQuestion);
          } else {
              setShowScore(true);
          }
      };


    const [picture, setPicture] = useState(null);
    const [imgData, setImgData] = useState(null);
    const onChangePicture = e => {
      if (e.target.files[0]) {
        console.log("picture: ", e.target.files);
        setPicture(e.target.files[0]);
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImgData(reader.result);
          console.log(picture)
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    };

    const [assignmentBody, setAssignmentBody] = useState("")
    const [assignmentRef, setAssignmentRef] = useState("")

    // console.log(picture)

    useEffect(() => {
        if(name) {
            setOpen(true)
        }
        if(!open) {
            setImgData(null);
        }
    }, [name]);


    const handleClose = () => {
        setOpen(false);

    }
    
    const handleSubmit = () => {
        setOpen(false);
        setSubmissionData({

        })
    }

return (
    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >
            
        <Box sx={style}>
            <IconButton style={{ position: "absolute", right: "10px", marginTop: "-20px" }} onClick={() => handleClose()}>
                <tableIcons.Close color="primary" />
            </IconButton>
        <h2 className="pageHeader3" style={{ textAlign: "center" }}>{name}</h2>
    
        <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justify="center"
                  style={{ marginBottom: "30px" }}
                  >
                  
             <ButtonGroup disableElevation variant="contained" color="primary" style={{ margin: "20px 0 -20px 0" }}>
              <Button variant={selectedDataSet === 1 ? "contained" : "outlined"} onClick={()=>setSelectedDataSet(1)}>Quiz</Button>
              <Button variant={selectedDataSet === 2 ? "contained" : "outlined"}  onClick={()=>setSelectedDataSet(2)}>Essay</Button>
             </ButtonGroup>
             </Grid>      
             
{selectedDataSet == 1 ? (
    <>
    
    <div className="quiz">
			{showScore ? (
				<div className='score-section'>
					You scored {score} out of {questions.length}
				</div>
			) : (
				<>
					<div className='question-section'>
						<div className='question-count'>
                        <div style={{ textAlign: "center" }}>
							<span>{currentQuestion + 1}</span>/{questions.length}
                            <div style={{ padding: "20px" }} />
                            {questions[currentQuestion].questionText}</div>
						</div>
						
					</div>
					<div className='answer-section'>
						{questions[currentQuestion].answerOptions.map((answerOption) => (
							<Button onClick={() => handleAnswerOptionClick(answerOption.isCorrect)}>{answerOption.answerText}</Button>
						))}
					</div>
				</>
			)}
		</div>

    </>
) : (
    <>
        <Button

    component="label"
    style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}
    >
    Upload Image
    <input
        type="file"
        className="playerProfilePic_home_title"
        onChange={onChangePicture}
        hidden
    />
    </Button>

    <div>
        <img style={{ maxWidth: "40vw", padding: "10px 0 30px 0", display: "block", marginLeft: "auto", marginRight: "auto" }} src={imgData} />
    </div>
            <Grid container justify="center"> 
            <TextField fullWidth label="Details" id="fullWidth" multiline={true} minRows="6" onChange={(e) => { setAssignmentBody(e.target.value) }} />
            <div style={{ margin: "10px" }} />
            <TextField fullWidth label="Reference links" id="fullWidth" multiline={true} minRows="2" onChange={(e) => { setAssignmentRef(e.target.value) }} />
    </Grid>
    </>
)}
       
      <Button
      onClick={() => handleSubmit()}
        variant="contained"
        component="label"
        style={{ float: "right", marginTop: "20px" }}
        >
    Submit Assignment
    </Button>
        </Box>
    </Modal>
)
};


export default NanoCompModal